import config from '../config';

export const pictureUrl = state => {
    const picture = state.widget.pictures.find(
        a => a.recipientPictureId === state.widget.activeAction.recipientPictureId
    );
    return (picture || {}).pictureUrl;
};

export const getImageUrl = (logoId, source = 'CDN_URL') => {
    return logoId != null ? `${config[source]}${logoId}` : null;
};
